import React from 'react';
import { map, values } from 'lodash';
import { connect } from 'react-redux';
import { Form, Field, Fields, reduxForm } from 'redux-form';
import {
  TextInputForm,
  TextAreaForm,
  DateForm,
  MultipleChoiceForm,
  SwitchForm,
  SelectboxForm,
  PhoneNumberSeparateForm,
  FullNameForm,
  AddressForm,
  FileForm,
  CheckBoxForm
} from './forms';
import { FormSubmitFooter } from './FormSubmitFooter.jsx';
import { validator, getValidationSets } from '../../../../../utils/validations';
import { getFieldName, getInitialValues, inspect, convertFormObject } from '../../../../../utils/formHelper.js';
import * as actions from '../../../../../actions';
import { SelectForm } from './forms/SelectForm';
import { TitleForm } from './forms/TitleForm';

class FormFieldBase extends React.Component {
  render () {
    const {
      index, objects, disabled, buttonStyle,
      onFocusFormCellInput, onBlurFormCellInput,
      valid,
      handleSubmit, onSubmit, reset, touch,
      submitButtonLabel, systemMessages,
      resetHidden,
    } = this.props;
    const isFormValid = !disabled && valid;

    return (
      <Form onSubmit={ handleSubmit(onSubmit) }>

        { map(objects, (object, idx) => {
          const inspected = inspect(object);
          const commonProps = {
            key: object.id,
            formCellIndex: index,
            index: idx,
            name: getFieldName(object),
            disabled,
            object,
            touch,
            systemMessages,
            inputCallbacks: {
              onFocus: onFocusFormCellInput,
              onBlur: onBlurFormCellInput,
            }
          };
          let c, nameMap;

          switch (object.purpose) {
            case 'short_text':
              return (
                <Field
                  { ...commonProps }
                  component={TextInputForm}
                />
              );

            case 'mail_address':
              return (
                <Field
                  { ...commonProps }
                  inputType="email"
                  inputMode="url"
                  component={TextInputForm}
                  isHalfWidth={true}
                />
              );

            case 'password':
              return (
                <Field
                  { ...commonProps }
                  inputType="password"
                  inputMode="url"
                  component={TextInputForm}
                  isHalfWidth={true}
                />
              );

            case 'number':
              return (
                <Field
                  {...commonProps}
                  component={SelectForm}
                />
              );

            case 'phone_number':
              if (inspected.phoneNumberSeparate) {
                const { areaCode, cityCode, subscriberNumber } = convertFormObject(object);
                const nameMap = {
                  areaCode: getFieldName(areaCode),
                  cityCode: getFieldName(cityCode),
                  subscriberNumber: getFieldName(subscriberNumber),
                };
                return (
                  <Fields
                    { ...commonProps }
                    name={undefined}
                    names={values(nameMap)}
                    nameMap={nameMap}
                    component={PhoneNumberSeparateForm}
                  />
                )
              } else {
                return (
                  <Field
                    { ...commonProps }
                    inputType="tel"
                    component={TextInputForm}
                  />
                );
              }

            case 'long_text':
              return (
                <Field
                  { ...commonProps }
                  component={TextAreaForm}
                />
              );

            case 'full_name':
              c = convertFormObject(object);
              nameMap = {
                firstName: getFieldName(c.firstName),
                lastName: getFieldName(c.lastName),
                firstNamePhonetic: c.firstNamePhonetic && getFieldName(c.firstNamePhonetic),
                lastNamePhonetic: c.lastNamePhonetic && getFieldName(c.lastNamePhonetic),
              };
              return (
                <Fields
                  { ...commonProps }
                  name={undefined}
                  names={values(nameMap)}
                  nameMap={nameMap}
                  component={FullNameForm}
                />
              );

            case 'date':
              return (
                <Field
                  { ...commonProps }
                  component={DateForm}
                />
              );

            case 'single_choice':
            case 'multiple_choice':
              return (
                <Field
                  { ...commonProps }
                  component={object.data && object.data.style === 'checkbox' ? CheckBoxForm : MultipleChoiceForm}
                />
              );

            case 'switch':
              return (
                <Field
                  { ...commonProps }
                  component={SwitchForm}
                />
              );

            case 'selectbox':
              return (
                <Field
                  { ...commonProps }
                  component={SelectboxForm}
                />
              );

            case 'address':
              c = convertFormObject(object);
              nameMap = {
                zipcodeZone: getFieldName(c.zipcodeZone),
                zipcodeArea: getFieldName(c.zipcodeArea),
                prefecture: getFieldName(c.prefecture),
                city: getFieldName(c.city),
                street: getFieldName(c.street),
              };
              if (c.extended) nameMap.extended = getFieldName(c.extended);
              return (
                <Fields
                  { ...commonProps }
                  name={undefined}
                  names={values(nameMap)}
                  nameMap={nameMap}
                  component={AddressForm}
                />
              );

            case 'title':
              return (
                <Field
                  { ...commonProps }
                  component={TitleForm}
                />
              )

            case 'file':
              return (
                <Field
                  { ...commonProps }
                  component={FileForm}
                />
              )
          }
        })}

        <FormSubmitFooter
          submitButtonLabel={submitButtonLabel || systemMessages.submitForm}
          systemMessages={systemMessages}
          onReset={reset}
          resetHidden={resetHidden}
          isFormValid={isFormValid}
          buttonStyle={buttonStyle}
          disabled={disabled}
        />

      </Form>
    );
  }
}

const mapStateToProps = ({ chatRoot }) => ({
  buttonStyle: {
    backgroundColor: chatRoot.baseParams.clientPromptBackgroundColor,
    color: chatRoot.baseParams.clientPromptColor,
  },
  systemMessages: chatRoot.systemMessages,
});

const mapDispatchToProps = dispatch => ({
  onFocusFormCellInput: () => dispatch(actions.onFocusFormCellInput()),
  onBlurFormCellInput: () => dispatch(actions.onBlurFormCellInput())
});

const FormField = connect(mapStateToProps, mapDispatchToProps)(FormFieldBase);

export const shouldError = () => { return true; };

export const createFormField = (key, objects) => {
  const validationSets = getValidationSets(objects);
  const initialValues = getInitialValues(objects);

  return reduxForm({
    form: key,
    validate: validator(validationSets),
    initialValues: initialValues,
    shouldError,
    destroyOnUnmount: false,
  })(FormField);
}
